function SongPanel(props: any) {
    return (<div className="parent h-36 w-32 flex flex-col justify-center">
        <div className="flex justify-center"><img src={process.env.PUBLIC_URL+"/images/jacket/jacket_"+props.id+'.png'} width="120px" alt={props.id+'_cover'}/></div>
        <div className="hiddenChild">
            <button className="text-base h-5 w-5 bg-yellow-300 m-1" onClick={() => {window.location.href='#/Chart?id='+props.id+'&level=1'}}>N</button>
            <button className="text-base h-5 w-5 bg-orange-300 m-1" onClick={() => {window.location.href='#/Chart?id='+props.id+'&level=2'}}>H</button>
            <button className="text-base h-5 w-5 bg-red-300 m-1" onClick={() => {window.location.href='#/Chart?id='+props.id+'&level=3'}}>A</button>
        </div>
    </div>)
}

export default SongPanel;